/**
 * THIS CODE IS AUTOMATICALLY GENERATED by @geenius/analytics codegen.
 *
 * Template version: 1.34-r3
 * Generated at: 2026-05-19
 * Convex SDK: ^1.34.0
 *
 * DO NOT EDIT THIS FILE MANUALLY.
 * To regenerate, run: pnpm codegen
 * @module
 */

import {
  actionGeneric,
  httpActionGeneric,
  internalActionGeneric,
  internalMutationGeneric,
  internalQueryGeneric,
  mutationGeneric,
  queryGeneric,
} from "convex/server";

export const query = queryGeneric;
export const internalQuery = internalQueryGeneric;
export const mutation = mutationGeneric;
export const internalMutation = internalMutationGeneric;
export const action = actionGeneric;
export const internalAction = internalActionGeneric;
export const httpAction = httpActionGeneric;
